import { render, staticRenderFns } from "./PortfolioInformation.vue?vue&type=template&id=18622f72"
import script from "./PortfolioInformation.vue?vue&type=script&lang=js"
export * from "./PortfolioInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports